import { render, staticRenderFns } from "./popup-layer.vue?vue&type=template&id=a8648198&scoped=true&"
import script from "./popup-layer.vue?vue&type=script&lang=js&"
export * from "./popup-layer.vue?vue&type=script&lang=js&"
import style0 from "./popup-layer.vue?vue&type=style&index=0&id=a8648198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8648198",
  null
  
)

export default component.exports